import React, { useEffect, useState } from "react";

import imgBack from "./prfimg.png";
import load1 from "./thg.gif";
import axios from "axios";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import { toast } from "react-toastify";
import "./ContactMe.css";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";

import Typical from "react-typical";
import   { useRef } from 'react';
import emailjs from '@emailjs/browser';
import styled from "styled-components";
import { Message } from "semantic-ui-react";

// const ContactMe = (props) => {
//   let fadeInScreenHandler = (screen) => {
//     if (screen.fadeInScreen !== props.id) return;

//     Animations.animations.fadeInScreen(props.id);
//   };
//   const fadeInSubscription = ScrollService.currentScreenFadeIn.subscribe(
//     fadeInScreenHandler
//   );

//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [message, setMessage] = useState("");
//   const [banner, setBanner] = useState("");
//   const [bool, setBool] = useState(false);

//   useEffect(() => {
//     return () => {
//       /* UNSUBSCRIBE THE SUBSCRIPTIONS */
//       fadeInSubscription.unsubscribe();
//     };
//   }, [fadeInSubscription]);

//   // handle inputs
//   const handleName = (e) => {
//     setName(e.target.value);
//   };

//   const handleEmail = (e) => {
//     setEmail(e.target.value);
//   };

//   const handleMessage = (e) => {
//     setMessage(e.target.value);
//   };

//   const formSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       let data = {
//         name,
//         email,
//         message,
//       };

//       setBool(true);

//       const res = await axios.post(`/contact`, data);

//       if (name.length === 0 || email.length === 0 || message.length === 0) {
//         setBanner(res.data.msg);
//         toast.error(res.data.msg);
//         setBool(false);
//       } else if (res.status === 200) {
//         setBanner(res.data.msg);
//         toast.success(res.data.msg);
//         setBool(false);

//         setName("");
//         setEmail("");
//         setMessage("");
//       }
//     } catch (err) {
//       console.log(err);
//     }
//   };
// }

  const Contact = () => {
     
    
    const form = useRef();
    const [messageSent, setMessageSent] = useState(false);
    const [btnappear, setbtnappear] = useState(false);

    const sendEmail = (e) => {
      e.preventDefault();
      
  
      emailjs
        .sendForm(
          "service_tkia3yo",
          "template_232n6l5",
          form.current,
          "owU4FZUGaSGLGoCxG"
        )
        .then(
          (result) => {
            console.log(result.text);
            console.log("message sent");
            setMessageSent(false); 
          },
          (error) => {
            console.log(error.text);
          }
        );
    };
    const fun=()=>{
      setMessageSent(false);
      document.getElementById("name").value=" ";
      document.getElementById("msg").value=" ";
      document.getElementById("email").value=" ";
    }
    const lafda=()=>{
       
      setMessageSent(true);
      setbtnappear(true);
     }

  return (
    <div className="main-container" id={ "Contact Me"|| ""}>
      <ScreenHeading
        subHeading={"Let's Keep In Touch"}
        title={" "? "Contact Me": ""}
      />
      <div className="central-form">
        <div className="col">
          <h2 className="title">
        

                {" "}
                <Typical
                  loop={Infinity}
                  steps={[
                    "Get in Touch 🤝",
                    1000,
                    
               
                
                  ]}
                />
            
        </h2>
         
        </div>

        <div className="back-form">
          <div className="img-back">
            <h4>Send your message</h4>
            <img src={imgBack} alt="" />
          </div>
          {/* <form onSubmit={formSubmit}>
            <p>{banner}</p>
            <label htmlFor="name">Name</label>
            <input type="text" onChange={handleName} value={name} />

            <label htmlFor="email">Email</label>
            <input type="email" onChange={handleEmail} value={email} />

            <label htmlFor="message">Message</label>
            <textarea
              type="text"
              onChange={handleMessage}
              value={message}
              name="message"
            /> */}

            {/* <div className="send-btn">
              <button type="submit">
                Send <i className="fa fa-paper-plane"></i>
                {bool ? (
                  <b className="load">
                    <img src={load1} alt="load1" />
                  </b>
                ) : (
                 " "
                )}
              </button>
            </div>
          </form> */}


<StyledContactForm>
      <form ref={form} onSubmit={sendEmail}>
        <label>Name</label>
        <input type="text" name="user_name" id="name" />
        <label>Email</label>
        <input type="email" name="user_email" id="email" />
        <label>Message</label>
        <textarea name="message" id="msg" />
        <input type="submit" value="Send" onClick={lafda} />
        {messageSent &&  <Message
              positive
              header="Thank You for Contacting me"
              content="Your Message Has Been Sent"
            />}
        {btnappear &&  
          <input type="submit" value="Clear" onClick={fun} 
          />
        }
       
        </form>
     
    </StyledContactForm>
   
    
        </div>
      </div>
      
    </div>
    
  );
};

export default Contact;

const StyledContactForm = styled.div`
  width: 450px;
  form {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 90%;
    font-size: 16px;
    input {
      width: 90%;
      height: 35px;
      padding: 7px;
      outline: none;
      border-radius: 5px;
      border: 1px solid rgb(220, 220, 220);
      &:focus {
        border: 2px solid rgba(0, 206, 158, 1);
      }
    }
    textarea {
      max-width: 90%;
      min-width: 90%;
      width: 90%;
      max-height: 100px;
      min-height: 100px;
      padding: 7px;
      outline: none;
      border-radius: 5px;
      border: 1px solid rgb(220, 220, 220);
      &:focus {
        border: 2px solid rgba(0, 206, 158, 1);
      }
    }
    label {
      margin-top: 1rem;
    }
    input[type="submit"] {
      cursor: pointer;
      background: rgb(79, 35, 92);
      color: white;
      border: none;
      margin-left: 10px;
      height:45px;
    }
    input[type="submit"]:hover {
     
      cursor: pointer;
      background:rgb(27, 158, 145);
      color: white;
      border: none;
      margin-left: 10px;
      height:50px;
      
    }
  }
`;